// monorepo/shared/auth/reducers.js
import {
    AUTH_LOADING,
    AUTH_SUCCESS,
    AUTH_FAILURE,
    AUTH_LOGOUT
  } from './Actions.jsx';

const initialState = {
  isAuthenticated: false,
  isLoading: false,
  user: null,
  error: null,
  permissions: [],
  roles: []
};

export function authReducer(state = initialState, action) {
  switch (action.type) {
    case AUTH_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    
    case AUTH_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        user: action.payload.user,
        permissions: action.payload.permissions || [],
        roles: action.payload.roles || [],
        error: null
      };
    
    case AUTH_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false,
        user: null,
        permissions: [],
        roles: [],
        error: action.payload || null
      };
    
    case AUTH_LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        permissions: [],
        roles: [],
        error: null
      };

    default:
      return state;
  }
}

// For persisting auth in localStorage
// Auth storage utilities
export const authStorage = {
  getToken: () => localStorage.getItem('auth_token'),
  setToken: (token) => localStorage.setItem('auth_token', token),
  removeToken: () => localStorage.removeItem('auth_token'),
  getUser: () => {
    const user = localStorage.getItem('auth_user');
    return user ? JSON.parse(user) : null;
  },
  setUser: (user) => localStorage.setItem('auth_user', JSON.stringify(user)),
  removeUser: () => localStorage.removeItem('auth_user')
};

export default authReducer;